import React from 'react';
import { useTranslation } from 'react-i18next';
import { trDisplay } from '../../i18n';
import { AlertTriangle } from 'lucide-react';

/**
 * Banner shown when simulation parameters have been modified
 * but the results still reflect the previous simulation run.
 */
const StaleResultsBanner = ({ variant = 'lombard' }) => {
  useTranslation();
  const colors = variant === 'lombard'
    ? 'bg-amber-50 border-amber-200 text-amber-800'
    : 'bg-amber-50 border-amber-200 text-amber-800';

  const iconColors = variant === 'lombard'
    ? 'text-amber-600'
    : 'text-amber-600';

  return (
    <div
      className={`${colors} border rounded-lg p-4 mb-6 flex items-start gap-3`}
      data-testid="stale-results-banner"
    >
      <AlertTriangle className={`h-5 w-5 ${iconColors} flex-shrink-0 mt-0.5`} />
      <div className="space-y-1">
        <p className="font-medium text-sm">
          {trDisplay("Hai modificato i parametri dello scenario.")}
        </p>
        <p className="text-sm opacity-90">
          {trDisplay("I risultati mostrati si riferiscono alla simulazione precedente. Premi")} <strong>{trDisplay('"Esegui simulazione"')}</strong> {trDisplay("per aggiornare i risultati.")}
        </p>
      </div>
    </div>
  );
};

export default StaleResultsBanner;
